
export function getTableOrderList({ orderList, tableInfo }) {
  const tOrders = [] // order only
  orderList.map((o) => {
    if (o.orderData.tableCode === tableInfo.tableCode) {
      o.orderData.orderList.map((orderItem) => {
        tOrders.push({ ...orderItem, created: o.created })
        return null
      })
    }
    return null
  })
  return { tableOrderList: tOrders }
}

/**
 * 
 * @param {*} param0 
 * @returns {Array} array of pure 
 *  orderObj { created, index, itemCode, optionItemCode, orderId, price, qty, type: "option" | undefined }
 */
export function getTableOrderListWithOptionItems({ orderList, tableInfo }) {
  const tOrders = [] // order only
  orderList.map((o, i) => {
    if (o.orderData?.tableCode === tableInfo.tableCode) {
      o.orderData?.orderList.map((orderItem, j) => {
        tOrders.push({ ...orderItem, orderId: o.orderId, index: j })

        if (orderItem.optionList.length > 0) {
          // console.log(orderItem.itemName, 'optionList', orderItem.optionList)
          orderItem.optionList.map((opt) => {
            tOrders.push({ ...opt, type: "option", orderId: o.orderId, index: j })
            return null
          })
        }
        return null
      })
    }
    return null
  })
  return { tableOrderList: tOrders }
}

export function getTime(ts) {
  if (ts) {
    const d = new Date(ts)
    const hr = d.getHours()
    const hour = (hr > 12) ? (hr - 12) : hr
    return `${hour}:${d.getMinutes()}`
  } else {
    return ""
  }
}

export function getAmt(ord, tableOrderList) {
  if (ord.type !== "option") return ord.qty * ord.price

  let optQty = getQty(ord, tableOrderList)
  return ord.price * optQty
}

export function getQty(ord, tableOrderList) {
  if (ord.type !== "option") return ord.qty

  let mainQty = 1

  const mainOrders = tableOrderList.filter(to => to.index === ord.index && to.type !== "option")
  if (mainOrders.length > 0) mainQty = mainOrders[0].qty

  return ord.qty * mainQty
}

export function getTotalAmt(tableOrderList) {
  let sum = 0
  for(const ord of tableOrderList) {
    sum += getAmt(ord, tableOrderList)    
  }
  return sum
}

export function getOrderSummary(orderList) {
  let orderAmt = 0
  let orderNames = []
  orderList.map((order) => {
    let itemName = order.itemName

    let optNameList = []
    let optPrice = 0
    order.optionList.map((opt) => {
      optNameList.push(opt.optionItemName)
      optPrice += opt.price
    })

    const optNames = '(' + optNameList.join(',') + ')'
    if (optNameList.length > 0) itemName += optNames
    if (order.qty > 1) itemName += ' x ' + order.qty

    orderNames.push(itemName)
    orderAmt += (parseInt(order.price) + optPrice) * order.qty
  })

  const orderName = orderNames.join(', ')
  return { orderAmt: orderAmt.toString(), orderName }
}